"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharingCapability = void 0;
let SharingCapability = exports.SharingCapability = /*#__PURE__*/function (SharingCapability) {
  /**
   * The service supports sharing custom text w/o the need to specify also URL.
   */
  SharingCapability["ShareText"] = "text";
  /**
   * The service supports sharing an URL. Standard functionality for most vendors.
   */
  SharingCapability["ShareUrl"] = "URL";
  /**
   * The service supports sharing URL and additional text.
   */
  SharingCapability["ShareUrlAndText"] = "URL and text";
  return SharingCapability;
}({});
/**
 * Specifies if given social sharing service supports specific sharing features,
 * like sharing text w/o specifying URL etc.
 */
